import actionTypes from '../constants/action-types';

const changeColorPalette = (isChanged) => ({
  type: actionTypes.CHANGE_COLOR_PALETTE,
  payload: {
    isChanged,
  },
});

export default changeColorPalette;
